import request from '@/utils/request'

// 平台列表
export function getPro(query) {
  return request({
    url: '/v1.0/iwrs/project/all?' + query,
    method: 'get'
  })
}

// 新增
export function addPro(data) {
  return request({
    url: '/v1.0/iwrs/project/add',
    method: 'post',
    data
  })
}

// 查询项目详情
export function detailPro(query) {
  return request({
    url: '/v1.0/iwrs/project/detail',
    method: 'get',
    params: query
  })
}

// 研究领域列表
export function ResearchList(query) {
  return request({
    url: '/v1.0/iwrs/project/research_field',
    method: 'get',
    params: query
  })
}

// 编辑项目信息
export function editPro(data) {
  return request({
    url: '/v1.0/iwrs/project/update',
    method: 'put',
    data
  })
}

